<template>
  <div class="clearfix main_center" :style="mainContentViewHeight"  v-loading.fullscreen.lock="loading">

    <div class="right-content clearfix busWinessRight" >

      <el-card class="box-card" v-if="!customFormShow">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <div class="processStatus">
          <img :src="pendingImg" v-if="warnForm.historyid == -1" :style="{'opacity':warnForm.warnLevel =='1'?'0.5':'1'}">
          <img :src="processedImg" v-if="warnForm.historyid == 0">
          <img :src="ignoreImg" v-if="warnForm.historyid == 1">
        </div>
        <el-form   label-width="130px" class="form viewFormWrapper">
          <el-row >
            <el-col :span="24">
              <el-form-item label="项目编号：" >
                <span >{{ warnForm.tenderProjectCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目名称：">
                <span >{{ warnForm.tenderProjectName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="12">
              <el-form-item label="招标人名称：" >
                <span >{{ warnForm.tendererName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理机构平台：">
                <span >{{ warnForm.tenderAgencyName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="12">
              <el-form-item label="交易类型：" >
                <span >{{ warnForm.busTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="交易平台：" >
                <span >{{ warnForm.platformName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </el-card>


      <el-card class="box-card" v-if="!customFormShow">
        <div slot="header" class="clearfix">
          <span>预警信息</span>
        </div>
        <el-form   label-width="130px" class="form viewFormWrapper">
          <el-row >
            <el-col :span="12">
              <el-form-item label="预警类别：" >
                <span >{{ warnForm.warnTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预警项：">
                <span >{{ warnForm.warnItemName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="24">
              <el-form-item label="预警内容描述：" >
                <span >{{ warnForm.warnContent }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="12">
              <el-form-item label="预警级别：" >
                <el-tag :type="warnForm.warnLevel =='1'?'':'danger'" size="small" :hit="false" effect="plain">{{warnForm.warnLevelName}} </el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预警时间：" >
                <span >{{ warnForm.warnTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <el-card class="box-card" v-if="!customFormShow" style="margin-bottom:10px">
        <div slot="header" class="clearfix">
          <span>操作记录</span>
        </div>
        <el-table
                :data="warnOptrecords"
                border
                :row-class-name="rowClassName"
                style="width: 100%">
          <el-table-column
                  prop="xh"
                  label="序号"
                  align="center"
                  width="80">
          </el-table-column>
          <el-table-column
                  prop="optBehavior"
                  label="操作"
                  align="center"
                  width="180">
          </el-table-column>
          <el-table-column
                  prop="optDesc"
                  align="center"
                  label="操作记录">
          </el-table-column>
          <el-table-column
                  prop="optUser"
                  align="center"
                  label="操作人">
          </el-table-column>
          <el-table-column
                  prop="optTime"
                  align="center"
                  label="操作时间">
          </el-table-column>
        </el-table>
      </el-card>

    </div>
    <div class="left-content busWinessLeft">
      <div class="left-navbar">
        <div class="pageInfo">
          <p class="title">系统标识码</p>
          <p>交易系统标识码 <br> <span>{{warnForm.platformCode}}</span></p>
          <p>公共服务平台标识码 <br><span>{{warnForm.pubServicePlatCode}}</span></p>
        </div>
        <el-button  type="primary" plain size="small" @click="showData">交易数据查看</el-button>
        <el-button  type="primary" plain size="small" :style="{display:(buttonVisible?'block':'none')}" @click="showAuditWindow(0,'')">处理</el-button>
        <el-button type="primary" plain size="small"  :style="{display:(buttonVisible?'block':'none')}" @click="showAuditWindow(1,'')">忽略</el-button>
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>

    <el-dialog title="处理意见" :visible.sync="dialogVisible" width="30%">
      <div class="dialogBox">
        <el-input type="textarea" v-model="auditForm.opinion"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handle()"  style="margin-bottom:20px;">确 定</el-button>
          <el-button @click="dialogVisible = false" class="backBtn">返回</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
  import {removeTabHandle, tabsCloseCurrentHandle} from "@/utils/routeTab";

  export default {
  props: ["mainContentViewHeight"],
  components: {
  },
  data() {
    return {
      id:'',
      loading:false,
      warnOptrecords:[],
      dialogVisible:false,
      opinion:'',
      buttonVisible: true,
      customFormShow: false,
      processedImg:require('@/assets/images/status_processed.png'),
      pendingImg:require('@/assets/images/status_pending.png'),
      ignoreImg:require('@/assets/images/status_ignore.png'),
      warnForm:{
        bidSectionCode:'',
        tenderProjectCode:'',
        projectCode:'',
        tenderProjectName:'',
        tendererName:'',
        historyId:"",
        tenderAgencyName:'',
        busType:'',
        busTypeName:'',
        platformName:'',
        warnTypeName:'',
        warnItemName:'',
        warnContent:'',
        warnLevelName:'',
        warnLevel:'',
        warnTime:'',
        platformCode:'',
        pubServicePlatCode:'',
        formId:'',
        flowId:'',
        entityId:'',
        purchaserMode:'',//采购方式
      },
      auditForm:{
        historyId:null,
        opinion:''
      },
      angleType:null,
      paramMap: {
        tenderProjectCode: '',
        bidSectionCode: '',
        projectCode:'',
        applyCode:"",
        idcard:"",
      }
    };
  },
  activated() {
    this.id = this.$route.query.id || '';
    this.angleType = this.$route.query.angleType?parseInt(this.$route.query.angleType):0;
    this.getDataContent()
    this.getListByPid();
  },
  methods: {

    showAuditWindow(historyId,msg){
      this.dialogVisible = true;
      this.auditForm.opinion = msg;
      this.auditForm.historyId = historyId;
    },
    
    getDataContent() {
      this.$http({
        url: '/jzWarnRecords/getWarnInfo?id='+this.id,
        method: 'get'
      }).then(({data}) => {
        if (data.code == '1') {
          this.warnForm = data.data
          this.paramMap = {...data.data}
        }
      })
    },
    back(){

      tabsCloseCurrentHandle();
      this.$router.push({
        name:'warn_record_list',
      })

      // this.$router.go(-1);//返回上一层
    },
    handle() {

      if (this.auditForm.opinion == '') {
        this.$message({
          message: '请填写处理意见',
          type: 'warning'
        });
        return;
      }
      this.$http({
        url: '/jzWarnRecords/handle?id='+this.id+"&opinion="+ this.auditForm.opinion + "&historyId="+this.auditForm.historyId,
        method: 'get'
      }).then(({data}) => {
        if (data.code == '1') {
          this.dialogVisible = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          tabsCloseCurrentHandle()
        } else {
          this.$message({
            message: '操作失败',
            type: 'warning'
          });
        }
      })
    },
    getListByPid() {

      if(this.id){
        this.$http({
          url: '/jzWarn0ptRecords/getListByPid?parentId='+this.id,
          method: 'get'
        }).then(({data}) => {
          if (data) {
            this.warnOptrecords = data.data;
            if (data.data.length > 0) {
              this.buttonVisible = false;
            }
          } else {
          }
        })
      }


    },
    showData() {



      window.sessionStorage.setItem("witnessHisDetailParamMap",JSON.stringify(this.paramMap))

      removeTabHandle("businessWitnessHis_detail")

      this.$router.push({
        name: "businessWitnessHis_detail",
        params: { paramMap:this.paramMap },
        query:{
          flowId:this.warnForm.flowId,
          entityId:this.warnForm.entityId,
          businessType:this.warnForm.busType || 'GC',
          angleType:this.angleType || 0,
          nodeCode:this.warnForm.nodeCode || '',
          purchaserMode:this.warnForm.purchaserMode
        },
      });
    },
    rowClassName({ row, rowIndex }) {
      row.xh = rowIndex + 1;
    }
  }
};
</script>

<style lang="less" scope>


  .right-content.busWinessRight{
    width: calc(100% - 160px);
    position: relative;

    .processStatus{
      position: absolute;
      right:20px;
      top: 20px;
      img{
        opacity: 0.5;
      }
    }

  }
  .left-content.busWinessLeft{
    .left-navbar{
      width:150px;
      border:none;
    }
  }


</style>
